import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { ButtonDirective } from '@pages/office/shared/components/button/button.directive';

@Component({
  selector: 'app-confirmation-events-modal',
  templateUrl: 'confirmation-events-modal.component.html',
  styleUrls: ['confirmation-events-modal.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
})
export class ConfirmationEventsModalComponent {
  @Input() title: string;

  @Input() prompt: string;

  public onConfirm = new EventEmitter<boolean>();

  private bsModalRef = inject(BsModalRef);

  confirm(): void {
    this.onConfirm.next(true);
    this.bsModalRef.hide();
  }

  decline(): void {
    this.onConfirm.next(false);
    this.bsModalRef.hide();
  }
}
